import * as Sentry from '@sentry/react';
import {
  generateApiKey,
  GenerateApiKeyProps,
} from '@/services/keys/generate-api-key';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useGenerateApiKey = (
  options?: Omit<
    UseMutationOptions<unknown, Error, GenerateApiKeyProps, unknown>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...options,
    mutationFn: generateApiKey,
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'generate-api-key' },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
